import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

import { isSp } from "../common/utils/device";

export default class Anchor {
    constructor() {
        this.isSp = true;

        if (isSp()) {
            this.isSp = true;
        } else {
            this.isSp = false;
        }

        this._init();
    }

    _init() {
        this._evetHandle();
    }

    _evetHandle() {
        const schedulsec = [...document.querySelectorAll(".schedule__section")];
        let urlParams = new URLSearchParams(window.location.search);

        const param = urlParams.get("place");

        schedulsec.forEach((el) => {
            const boxid = el.id;

            if (boxid === param) {
                this._setSmoothScroll(el);
            }
        });
    }

    _setSmoothScroll(el) {
        if (this.isSp) {
            var scrollSet = 85;
        } else {
            var scrollSet = 190;
        }

        const y =
            el.getBoundingClientRect().top + window.pageYOffset - scrollSet;

        gsap.to(window, {
            duration: 0.8,
            scrollTo: y,
            ease: "power2.out",
        });
    }
}
